var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"num"},[_vm._v("\n  "+_vm._s(_vm.output)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }